"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIdWithUniqueFallback = void 0;
const countNamespace = {};
function getIdWithUniqueFallback(options, prefix = 'uid') {
    const passedId = options === null || options === void 0 ? void 0 : options.find(Boolean);
    if (passedId) {
        return passedId;
    }
    if (!(prefix in countNamespace)) {
        countNamespace[prefix] = 0;
    }
    return `${prefix}-${countNamespace[prefix]++}`;
}
exports.getIdWithUniqueFallback = getIdWithUniqueFallback;
